// src/shared/utils/brandName.ts
//
// Sustituye nombres "canónicos" Ainovis/Carolina por los de la marca activa en
// cadenas provenientes de DATOS que se muestran en la UI (p. ej. nombres de
// plantillas o respuestas del backend).
//
// - `applyBrandName`: "Ainovis" → productName (p. ej. "ALMA").
// - `applyAssistantName`: "Carolina" → assistantName (p. ej. "ASSISTANT").
//
// Son complementarios al post-procesador i18n (que cubre las traducciones
// estáticas). Úsalos SOLO en el punto de renderizado (display), nunca para
// mutar el dato original: el nombre crudo se sigue usando para comparaciones
// (p. ej. detección de duplicados) y para identificar la plantilla.

import { config } from '../../config/env';
import { getBrandConfig } from '../../config/brand';

const BRAND_PRODUCT_NAME = getBrandConfig(config.BRAND).productName;
const BRAND_ASSISTANT_NAME = getBrandConfig(config.BRAND).assistantName;

/**
 * Devuelve `text` con la palabra "Ainovis" reemplazada por el nombre de la
 * marca activa. Para la marca por defecto (Ainovis) devuelve el texto tal cual.
 * La búsqueda es insensible a mayúsculas para cubrir nombres como
 * "AINOVIS RM Rodilla" o "ainovis tórax".
 */
export function applyBrandName(text: string | null | undefined): string {
  if (!text || BRAND_PRODUCT_NAME === 'Ainovis') return text ?? '';
  return text.replace(/Ainovis/gi, BRAND_PRODUCT_NAME);
}

/**
 * Devuelve `text` con la palabra "Carolina" (nombre del asistente de IA) cambiada
 * por el nombre de la marca activa. Para la marca por defecto (Ainovis) devuelve
 * el texto tal cual. Insensible a mayúsculas para cubrir "CAROLINA" / "carolina".
 */
export function applyAssistantName(text: string | null | undefined): string {
  if (!text || BRAND_ASSISTANT_NAME === 'Carolina') return text ?? '';
  return text.replace(/Carolina/gi, BRAND_ASSISTANT_NAME);
}

/**
 * Nombre de producto de la marca activa (p. ej. "ALMA" / "Ainovis"). Se envía al
 * backend (cabecera X-Brand-Name en peticiones axios, campo `brand` en las
 * peticiones de voz) para que la búsqueda fuzzy de plantillas sea agnóstica a la
 * marca: en BD las plantillas siguen llamándose "Ainovis" aunque la UI muestre
 * "ALMA".
 */
export function getActiveBrandProductName(): string {
  return BRAND_PRODUCT_NAME;
}
